import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import AuthRoutes from "Routes/Components/Auth";

import UseAuth from "Hooks/UseAuth";

import Stepper from "./Components/Stepper";
import FirstForm from "./Forms/First";
import SecondForm from "./Forms/Second";
import * as S from "./styles";

const UpdateProject = ({ id, project, reload, isDownload = false }) => {
  const { authorized, parsedJWT } = UseAuth();
  const navigate = useNavigate();

  const [projectId, setProjectId] = useState(null);
  const [step, setStep] = useState(0);
  const [projectData, setProjectData] = useState(project);

  useEffect(() => {
    if (!authorized) {
      navigate(AuthRoutes.Dashboard.path);
    }
  }, [authorized]);

  useEffect(() => {
    setProjectId(id);
  }, [id]);

  const is_sponsor = parsedJWT?.user?.is_sponsor;

  const switchForm = (step) => {
    switch (step) {
      case 0:
        return (
          <FirstForm
            setStep={setStep}
            projectId={projectId}
            setProjectId={setProjectId}
            projectData={projectData}
            setProjectData={setProjectData}
            isUpdate
            disabled={is_sponsor}
          />
        );
      case 1:
        return (
          <SecondForm
            setStep={setStep}
            projectId={projectId}
            projectData={projectData}
            setProjectData={setProjectData}
            isUpdate
            disabled={is_sponsor}
            reload={reload}
          />
        );
      default:
        return (
          <FirstForm
            setStep={setStep}
            setProjectId={setProjectId}
            projectData={projectData}
            setProjectData={setProjectData}
            isUpdate
          />
        );
    }
  };

  return !isDownload ? (
    <S.Wrapper>
      <Stepper step={step} />
      {projectData ? switchForm(step) : null}
    </S.Wrapper>
  ) : (
    <S.Wrapper isDownload={isDownload}>
      <Stepper step={step} />
      {projectData ? (
        <>
          <FirstForm
            setStep={setStep}
            setProjectId={setProjectId}
            projectData={projectData}
            setProjectData={setProjectData}
            isUpdate
            isDownload
          />
          <SecondForm
            setStep={setStep}
            projectId={projectId}
            projectData={projectData}
            setProjectData={setProjectData}
            isUpdate
            disabled={is_sponsor}
            reload={reload}
            isDownload
          />
        </>
      ) : null}
    </S.Wrapper>
  );
};

export default UpdateProject;
